import { getErrorMessage, isAuthRequest, isAuthResponse, normalizeRequestError } from "./requestErrors";

export const installRequestInterceptors = (client, { getToken, setToken, onUnauthorized, onError }) => {
  const requestId = client.interceptors.request.use(async (request) => {
    if (isAuthRequest(request.url)) {
      request.timeout = request.timeout || 20000;
    } else {
      const token = await getToken();
      if (token) request.headers = { ...request.headers, Authorization: `Bearer ${token}` };
    }
    return request;
  });

  const responseId = client.interceptors.response.use(async (response) => {
    if (isAuthRequest(response.config.url)) {
      if (!isAuthResponse(response)) throw new Error("INVALID_AUTH_RESPONSE");
      await setToken(response.data.access_token);
    }
    return response;
  }, async (error) => {
    const url = error?.config?.url || error?.response?.config?.url;
    if (!isAuthRequest(url)) {
      if (error?.response?.status === 401) await onUnauthorized();
      onError(getErrorMessage(error));
    }
    // Un error nunca debe entrar en los .then que guardan datos o anuncian éxito.
    return Promise.reject(normalizeRequestError(error));
  });

  return () => {
    client.interceptors.request.eject(requestId);
    client.interceptors.response.eject(responseId);
  };
};
